import React from "react";

const LiveRateTable = ({ data, headings }) => {
  
  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };
  return (
    <section className="border-2 mt-5 rounded-xl p-2 mb-10">
      <div className="w-fit   tracking-widest px-4 font-semibold text-xs p-1 text-white  bg-yellow-700 m-2 rounded-lg blinkLive">
        LIVE
      </div>
      <table className="w-full m-auto text-center">
        <thead className="bg-base-200">
          <tr className="bg-orange-100 text-xs rounded-lg">
            {headings.map((heading, index) => (
              <th
                className={` text-black py-2 px-4 ${
                  index === 0 ? "rounded-tl-lg" : ""
                } ${index === headings.length - 1 ? "rounded-tr-lg" : ""}`}
                key={index}
              >
                {heading}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="bg-gray-100 text-xs">
          <tr>
            <td className="py-4  ">{data.Rate24Karat}</td>
            <td className="py-4 ">{data.Rate22Karat}</td>
            <td className="py-4 ">{data.Rate21Karat}</td>
            <td className="py-4 ">{data.Rate18Karat}</td>
            <td className="py-4  ">{data.Rate14Karat}</td>
            <td className="py-4  ">{formatTimestamp(data.Timestamp)}</td>
          </tr>
        </tbody>
      </table>
    </section>
  );
};

export default LiveRateTable;
